export const smtpsApis = {
    getSmtps: 'v1/api/smtps',
    createSmtps: 'v1/api/smtps',
    editSmtps: 'v1/api/smtps?smtpsId=',
    deleteSmtps: 'v1/api/smtps',
    getSmtpsByTenantId: 'v1/api/smtps/:tenantId',
    getSMTPBYid: 'v1/api/smtps/tenantId?smtpId='
}
